import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const letters = "NABIL".split("");

export default function LoadingScreen({ onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence onExitComplete={onDone}>
      {visible && (
        <motion.div
          data-testid="loading-screen"
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center"
          style={{ background: "#080808" }}
        >
          <svg width="72" height="72" viewBox="0 0 64 64" fill="none" className="mb-6">
            <g stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" className="scissor-path">
              <circle cx="18" cy="46" r="7" fill="none" />
              <circle cx="18" cy="18" r="7" fill="none" />
              <line x1="24" y1="41" x2="54" y2="14" />
              <line x1="24" y1="23" x2="54" y2="50" />
              <circle cx="33" cy="32" r="2" fill="#C9A84C" />
            </g>
          </svg>
          <div className="flex">
            {letters.map((l, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, y: 12, color: "#C9A84C" }}
                animate={{ opacity: 1, y: 0, color: "#F5F0E8" }}
                transition={{ delay: 0.5 + i * 0.08, duration: 0.5 }}
                className="font-display text-5xl sm:text-6xl font-bold"
                style={{ letterSpacing: "0.1em" }}
              >
                {l}
              </motion.span>
            ))}
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.1, duration: 0.5 }}
            className="mt-4 text-xs"
            style={{ letterSpacing: "6px", color: "#C9A84C" }}
          >
            BARBERSHOP · BOCHUM
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
